module.exports = __webpack_public_path__ + "img/location-uk.daf93767.svg";